<!-- SucursalCard.vue -->
<template>
    <div class="card has-border-green-light is-height-auto">
        <h4 class="mb-3">
            <strong>{{ cardTitle }}:
                <a>{{ office.name }}</a>
            </strong>
        </h4>
        <div v-if="this.office.is_municipal">
            <p>
                En este lugar, puedes realizar los mismos
                trámites que en una <a href="http://chileatiende.loc/sucursalvirtual" class="is-link-underline">videoatención</a>.
            </p>
            <br>
        </div>

        <div class="is-flex is-justify-content-start is-align-items-start mb-3">
            <i class="las la-map-marker is-size-4 has-text-primary mr-3"></i>
            <p>{{ office.address }}</p>
        </div>

        <div class="is-flex is-justify-content-start is-align-items-start mb-3"
            :class="{ 'has-text-danger': office.is_suspended }">
            <i :class="[
                'las',
                'la-clock',
                'is-size-4',
                office.is_suspended ? 'has-text-danger' : 'has-text-primary',
                'mr-3'
            ]"></i>
            <p :class="{ 'has-text-danger': office.is_suspended }">
                {{ office.is_suspended ? 'Atención suspendida' : displaySchedule }}
            </p>
        </div>

        <div v-if="office.location_observations !== ''"
            class="is-flex is-justify-content-start is-align-items-start mb-3">
            <i class="las la-info-circle is-size-4 has-text-primary mr-3"></i>
            <p>{{ office.location_observations }}</p>
        </div>

        <div v-if="office.observations !== ''"
            class="is-flex is-justify-content-start is-align-items-start mb-3">
            <i class="las la-info-circle is-size-4 has-text-primary mr-3"></i>
            <span v-html="office.observations"></span>
        </div>


        <div v-if="office.has_mex" class="is-flex is-justify-content-start is-align-items-start mb-3">
            <i class="las la-info-circle is-size-4 has-text-primary mr-3"></i>
            <p>Tiene Módulo Express</p>
        </div>
        <div class="is-flex is-justify-content-space-between is-flex-wrap">
            <button v-if="showMapButton" type="button" class="button is-default" @click="openMap">
                Ir al mapa
            </button>

            <button v-if="office.is_scheduled" type="button" class="button is-primary" @click="openScheduled">
                <span class="icon">
                    <i class="las la-calendar-check is-size-4"></i>
                </span>
                <span class="text">
                    Agendar atención
                </span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SucursalCard',
    props: {
        office: {
            type: Object,
            required: true
        }
    },
    computed: {
        cardTitle() {
            let name = 'Sucursal ChileAtiende';
            if (this.office.mobile) {
                name = 'Atención móvil ChileAtiende';
            }
            if (this.office.is_municipal) {
                //name = 'Punto de Atención Virtual Municipal';
                name = 'Centro de Atención Virtual (CAV)'
            }
            return name;
        },
        displaySchedule() {
            return this.office.horarios;
        },
        showMapButton() {
            if (this.office.map_type === 'url') {
                // Si es tipo url, mostrar solo si hay una URL válida
                return this.office.map_url && this.office.map_url.trim() !== '';
            }
            // Para tipo coordinates o sin tipo especificado
            return this.office.lat != null &&
                this.office.lng != null &&
                this.office.lat !== 0 &&
                this.office.lng !== 0;
        },
    },
    methods: {
        openMap() {
            // No mostrar el botón, no hacer nada
            if (!this.showMapButton) {
                return;
            }

            let url = '';
            if (this.office.map_type === "url") {
                if (!this.office.map_url) {
                    return;
                }
                url = this.office.map_url;
            } else {
                if (!this.office.lat || !this.office.lng) {
                    return;
                }
                url = `http://maps.google.com/maps?q=loc:${this.office.lat},${this.office.lng}`;
            }

            window.open(url, '_blank');
        },
        openScheduled() {
            const url = "https://www.chileatiende.gob.cl/agendamiento";
            window.open(url, '_blank');
        }
    }
}
</script>
